import Quartiles from '../model/Quartiles';
import SimilarProduct from '../model/SimilarProductModel';
import {
  capitalizeFirstLetter,
  ecsColor,
  ecsLetter,
  formatPrice,
} from '../utils/utils';
import { details_url } from '../utils/variables';

export default function SimilarProductsComponent(props: {
  products: SimilarProduct[];
  quartiles: Quartiles;
  isGlobal: boolean;
  category: string;
}) {
  return (
    <div className="row-span-1 col-span-1 rounded-xl p-6 bg-blackOverlay dark:bg-whiteOverlay ">
      <p className="text-xl font-semibold">Articles similaires</p>
      <div className="flex gap-4 justify-between items-center h-full xl:mt-0 mt-2 pt-4">
        {props.products.map((p) => {
          return (
            <div
              key={p.product.id}
              onClick={() =>
                window.open(
                  details_url +
                    '?id=' +
                    p.product.id +
                    '&origin=similar-' +
                    Date.now() +
                    '&global=' +
                    props.isGlobal,
                )
              }
              className="relative w-[23%] short:w-[21%] h-full transition-all duration-500 hover:scale-105 cursor-pointer"
            >
              <div
                className={
                  'rounded-full md:w-10 md:h-10 w-6 h-6 short:w-9 short:h-9 flex justify-center items-center absolute right-[-10px] top-[-10px] translate-all ease-in-out duration-300 ' +
                  ecsColor(
                    p.product.impacts.global_ecs,
                    props.quartiles,
                    props.isGlobal,
                    props.category,
                  )
                }
              >
                <p className="text-center font-medium md:text-base text-white text-xs">
                  {ecsLetter(
                    p.product.impacts.global_ecs,
                    props.quartiles,
                    props.isGlobal,
                    props.category,
                  )}
                </p>
              </div>
              <img
                className="rounded-md w-full h-[75%] object-cover"
                src={p.product.url_image}
                alt="product"
              />
              <div className="flex justify-between items-center mt-2 text-sm">
                <div className="w-[60%]">
                  <p className="italic text-sm text-darkLight dark:text-whiteLight">
                    {capitalizeFirstLetter(p.product.site)}
                  </p>
                </div>
                <p>{formatPrice(p.product.price)}</p>
              </div>
            </div>
          );
        })}
        {(props.products.length === 0 || props.products == null) && (
          <p className="text-center w-full">Aucun articles similaire</p>
        )}
      </div>
    </div>
  );
}
